<template>
  <v-container fluid>
    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>
            Поиск по фразам
          </v-card-title>

          <v-form ref="form">
            <v-card-text>
              <Report-Filters @load-report="loadReport" v-model="filters" />
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>
            <div v-if="meta.total > 0">Всего результатов {{ meta.total }}</div>
          </v-card-title>

          <!-- Пагинация над таблицей -->
          <v-row v-if="report.items.length > 0">
            <v-col cols="3">
              <v-pagination
                v-model="meta.current_page"
                :total-visible="paginationTotalVisible"
                :length="meta.last_page"
                @input="pageChange"
              />
            </v-col>

            <v-spacer />

            <v-col cols="3">
              <v-select v-model.lazy="perPage" :items="perPages" label="Отображать на странице" />
            </v-col>
          </v-row>

          <!-- Таблица -->
          <v-data-table
            :headers="report.headers"
            :items="report.items"
            :items-per-page="perPage"
            :sort-by="orderBy"
            :sort-desc="orderDesc"
            :server-items-length="meta.total"
            :loading="loading"
            loading-text="Загрузка..."
            no-data-text="Ничего не найдено"
            @update:sort-by="order('orderBy', $event)"
            @update:sort-desc="order('orderDesc', $event)"

            hide-default-footer
          >
            <template #[`item.date`]="{item}">
              {{ utils.formattingStringWithTime(item.date, true /*с секундами*/) }}
            </template>
            <template #[`item.transcribe`]="{item}">
              <div
                v-if="allowTranscribe"
                class="px-1 py-1 table-transcribe"
                style="max-height: 150px;"
              >
                <Transcribe v-if="!loading" :messages="item.transcribe" :table-mode="true" />
              </div>
              <v-chip
                v-else
                small
                color="error"
                dark
              >
                Нет доступа к просмотру стенограммы.
              </v-chip>
            </template>

            <template #[`item.matched`]="{item}">
              <v-chip
                small
                color="primary"
                v-if="allowTranscribe"
                v-text="matched(item.transcribe)"
              />
              <v-chip
                small
                color="error"
                dark
                v-else
                v-text="`Нет доступа к просмотру стенограммы.`"
              />
              <span></span>
            </template>

            <template #[`item.status_name`]="{item}">
              <v-chip
                small
                :color="statusChip(item.status)"
                dark
              >
                {{ item.status_name }}
              </v-chip>
            </template>

            <template #[`item.actions`]="{ item }">
              <v-btn icon @click="viewItem(item)">
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
              <v-btn icon :href="`http://statix.oline/calls/${item.uid}`" target="_blank">
                <v-icon>mdi-dock-window</v-icon>
              </v-btn>
            </template>

          </v-data-table>

          <!-- Пагинация под таблицей -->
          <v-row v-if="perPage >= 25 && report.items.length > 0" class="ml-10">
            <v-col cols="3">
              <v-pagination
                v-model="meta.current_page"
                :total-visible="paginationTotalVisible"
                :length="meta.last_page"
                @input="pageChange"
              />
            </v-col>

            <v-spacer />

            <v-col cols="3">
              <v-select v-model.lazy="perPage" :items="perPages" label="Row per Page" />
            </v-col>

          </v-row>

        </v-card>
      </v-col>
    </v-row>

    <Dialog-View v-if="dialogView" v-model="dialogView" fullscreen title="Просмотр информации о вызове22">
      <Call-Info :uid="dialogViewUid" />
    </Dialog-View>
  </v-container>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import {requiredRule} from "~/plugins/rules";
import Transcribe from "~/components/partials/Call/Transcribe";
// import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';
import ReportFilters from '~/components/pages/stat/elements/ReportFilters.vue';

export default {
  components: {
    Transcribe,
    // ProjectSelector,
    ReportFilters,
  },

  data() {
    return {
      formRules: {
        valid: false,
        required: requiredRule,
      },
      date: {},
      projects: [],
      queues: [],
      searchPhrase: '',
      phraseOwner: ["agent"],
      // call: {},
      report: {
        headers: [
          {
            text: "Дата звонка",
            value: "date",
          },
          {
            text: "Проект",
            sortable: false,
            value: "project",
          },
          {
            text: "Очередь",
            sortable: false,
            value: "queue",
          },
          {
            text: "Совпадений",
            sortable: false,
            value: "matched",
          },
          {
            text: "Фраза",
            width: 750,
            sortable: false,
            value: "transcribe",
          },
          {
            text: "Статус звонка",
            sortable: false,
            value: "status_name",
          },
          {
            text: 'Actions',
            value: 'actions',
            sortable: false
          },
        ],
        items: [],
        payload: {},
      },
      perPage: 25,
      perPages: [5, 10, 20, 25, 50, 100],
      page: 1,
      paginationTotalVisible: 7,
      orderBy: 'date',
      orderDesc: true,
      dialogView: false,
      dialogViewUid: null,

      filters: {},
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: "user/hasPermission",
      projectsGetter: "projects/projects",
      queuesGetter: "projects/queues",
      filteredQueues: "projects/filteredQueues",
      loading: "shared/getLoading",
      meta: "shared/meta",
      call: "reports/call",
    }),

    payload() {
      let payload = {
        page: this.page,
        limit: this.perPage,
        with: "transcribe",
        filter: {
          ...this.filters,
          ...this.phraseFilter,
        },
      }

      payload.filter.period_between = [
        moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss'),
        moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss'),
      ];

      delete payload.filter.search_phrase
      delete payload.filter.period

      return payload;
    },
    phraseFilter() {
      if (this.filters.search_phrase.who_said.includes("agent")) return {phrase_agent: this.filters.search_phrase.phrase}
      if (this.filters.search_phrase.who_said.includes("client")) return {phrase_client: this.filters.search_phrase.phrase}
      return {phrase_both: this.search_phrase.phrase}
    },
    allowTranscribe() {
      return this.hasPermission("statiz.call-transcribe")
    },
    sortFilter() {
      let order = this.orderDesc ? "" : "-"

      return `${order}${this.orderBy}`
    }
  },

  watch: {
    // search() {
    //     if (this.search.length > 3) {
    //         this.refreshTable()
    //     } else if (this.search.length === 0) {
    //         this.refreshTable()
    //     }
    // },
    call(newVal) {
      if (newVal !== null) {
        this.dialogView = true;
      } else {
        this.dialogView = false;
      }
    },
    perPage() {
      this.page = 1
      this.refreshTable()
    },
  },

  methods: {
    ...mapActions({
      // loadProjects: "projects/loadProjects",
      loadQueues: "projects/loadQueues",
      loadTranscribeSearch: "reports_speech_analysis/loadTranscribeSearch",
      //loadCall: "reports/loadCall",
      resetAllState: 'resetAllState',
    }),

    viewItem(call) {
      this.dialogViewUid = call.uid;
      this.dialogView = true;
      //this.loadCall({uid: call.uid, query: {with: 'transcribe,audios,markers'}});
      // this.loadCall({uid: call.uid, query: {with: 'transcribe,audios,markers'}}).then((call) => {
      //     this.call = call
      //     this.dialogView = true
      // });
    },

    pageChange(page) {
      this.page = page
      this.refreshTable()
    },

    loadReport() {
      this.page = 1
      this.refreshTable()
    },

    refreshTable() {
      if (this.$refs.form.validate()) {
        this.loadTranscribeSearch(this.payload).then((resp) => {
          this.report.payload = this.payload
          this.report.payload.phrase = this.searchPhrase
          this.report.payload.phraseOwner = this.phraseOwner
          this.report.items = resp
        })
      }
    },

    order(source, $event) {
      switch (source) {
        case "orderBy":
          this.orderBy = $event === undefined ? [] : $event
          break;
        case "orderDesc":
          this.orderDesc = $event === undefined ? [] : $event
          break;
      }

      if (this.orderBy.length !== 0 && this.orderDesc.length !== 0) {
        this.refreshTable()
      }
    },

    statusChip(status) {
      switch (status) {
        case "success":
          return "primary"
        case "warning":
          return "warning"
        case "danger":
          return "error"
        case "info":
          return "info"
        default:
          return "default"
      }
    },

    phrases(data) {
      let currentIdx = data.findIndex(p => p.text.toLowerCase().search(this.report.payload.phrase.toLowerCase()) !== -1 && p.is_client === this.report.payload.phraseOwner.includes("client"))
      let prePhrase = this.wrapPhrase(data[currentIdx - 1])
      let curPhrase = this.wrapPhrase(data[currentIdx])
      let nextPhrase = this.wrapPhrase(data[currentIdx + 1])

      return `${prePhrase}${curPhrase}${nextPhrase}`
    },

    wrapPhrase(phrase) {
      if (!phrase) {
        return ""
      }
      let uppercasedPhrase = "";

      if (phrase.is_client === this.report.payload.phraseOwner.includes("client")) {
        uppercasedPhrase = phrase.text.replace(this.report.payload.phrase.toLowerCase(), this.report.payload.phrase.toUpperCase())
      } else {
        uppercasedPhrase = phrase.text
      }

      return !phrase.is_client ?
          `<div class="d-flex flex-row-reverse">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-face-agent"></i>
                        <span class="green--text pl-5 pr-5">
                            ${uppercasedPhrase}
                        </span>
                        </div>
                    <br>` :
          `<div class="d-flex">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-face"></i>
                        <span class="pl-5 pr-5">
                            ${uppercasedPhrase}
                        </span>
                        </div>
                    <br>`
    },

    matched(transcribe) {
      let count = 0
      transcribe.forEach(t => {
        count += t.text.toLowerCase().split(this.report.payload.phrase.toLowerCase()).length - 1
      })
      return count;
    },
  },

  mounted() {
    // document.getElementById("focusOnload").focus();
    this.loadQueues();
  },

  beforeDestroy() {
    this.resetAllState();
  },
}
</script>

<style>
.v-dialog--fullscreen > .v-card > .container {
  padding-bottom: 70px;
}

.v-dialog--fullscreen > .theme--light.v-card {
  background-color: #fafafa;
}

.v-dialog--fullscreen > .theme--dark.v-card {
  background-color: #121212;
}
</style>

<style scoped>

</style>
